import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// TS type
import { RootState } from '@redux/store';
import { IGDSSessionItem } from '@redux/common';

// import module
import IcRcln from '@magaele/ic_rcln';

// shared component
import Session from '@component/Common/session';

// common function
import { isMobile } from '@libs/globalVariables';

// plugin
import { useTranslation } from 'react-i18next';

// redux actions
import { setGSessionErr, setSessionPicked } from '@redux/GDS/actions';

interface IGSessionProps {} //TODO: 空定義

const SessionBlock: React.FC<IGSessionProps> = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { session, sessionPicked, GSessionErr } = useSelector((state: RootState) => state.GDS);
    let optionData = [{ text: t('noTHSR.session.choose', {particle: t('THSR.commonPanel.please')}), value: '' }];
    
    const formatTime = (time: string) => {
        return time
            .split('-')
            .map((timeItem) => {
                if (timeItem && timeItem.trim() === '') return '';
                return timeItem.trim().split(':')[0] + ':' + timeItem.trim().split(':')[1];
            })
            .join(' - ');
    };
    if (session && session.length !== 0) {
        optionData = session.map((item: IGDSSessionItem) => {
            return {
                text: formatTime(item.Session),
                value: item.Session + '|' + item.SessionUUID,
            };
        });
    }

    const sessionPickVal = (() => {
        if (sessionPicked) {
            return `${sessionPicked?.Session}|${sessionPicked?.SessionUUID}`;
        }
        return undefined;
    })();

    const sessionProps = {
        option: optionData,
        sessionPicked: sessionPickVal,
        // defaultValue: !!session ? optionData[0].value : undefined,
        itemClick: (idx: number) => {
            // console.log('sessionitemClickvalue', idx);
            dispatch(
                setSessionPicked({
                    Session: optionData[idx].value.split('|')[0],
                    SessionUUID: optionData[idx].value.split('|')[1],
                })
            );
            GSessionErr && dispatch(setGSessionErr(''));
        },
        onChangeCallBack: (value: string) => {
            // console.log('dropdownSelectedvalue', value);
            dispatch(
                setSessionPicked({
                    Session: value.split('|')[0],
                    SessionUUID: value.split('|')[1],
                })
            );
            GSessionErr && dispatch(setGSessionErr(''));
        },
        icon: [<IcRcln name="clock" className="svg" />],
        isMobile,
        isGDS: true,
    };
    return (
        <>
            {session ? (
                <Session {...sessionProps} />
            ) : (
                <div className="noSession">{t('noTHSR.session.sorryForNoSessions')}</div>
            )}
        </>
    );
};

export default SessionBlock;
